var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.inline ? 'div' : 'v-dialog', _vm._g(_vm._b({
    tag: "component"
  }, 'component', _vm.dialogProps, false), _vm.dialogListeners), [_c(_vm.inline ? 'div' : 'v-card', {
    tag: "component",
    "class": _vm.inline ? '' : 'premium-feature-gate-card d-flex flex-column'
  }, [_c(_vm.inline ? 'div' : 'v-card-text', {
    tag: "component",
    "class": _vm.inline ? '' : 'premium-feature-gate-body flex-grow-1 pa-0 overflow-y-auto'
  }, [_c('div', {
    staticClass: "premium-feature-gate pa-8"
  }, [_c('div', {
    staticClass: "text-center mb-4"
  }, [_c('div', {
    staticClass: "icon-container mb-4"
  }, [_c('div', {
    staticClass: "icon-wrapper animate-float"
  }, [_c('div', {
    staticClass: "premium-gradient icon-background"
  }, [_c('v-icon', {
    attrs: {
      "size": "56",
      "color": "white"
    }
  }, [_vm._v("mdi-check-circle")])], 1), _c('div', {
    staticClass: "icon-badge icon-badge-star"
  }, [_c('v-icon', {
    attrs: {
      "size": "20",
      "color": "yellow darken-2"
    }
  }, [_vm._v("mdi-star")])], 1), _c('div', {
    staticClass: "icon-badge icon-badge-chart"
  }, [_c('v-icon', {
    attrs: {
      "size": "20",
      "color": "primary"
    }
  }, [_vm._v("mdi-chart-line")])], 1)])]), _c('h2', {
    staticClass: "text-h5 font-weight-bold mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$translate('premiumFeatureTitle')) + " "), _c('span', {
    staticClass: "premium-gradient-text"
  }, [_vm._v(_vm._s(_vm.$translate('premium')))])]), _c('div', {
    staticClass: "premium-feature-gate-content text-center mb-4"
  }, [_vm._t("content", function () {
    return [_c('p', {
      staticClass: "text-body-2 text--secondary max-width-lg mx-auto"
    }, [_vm._v(" " + _vm._s(_vm.$translate('premiumFeatureDescription')) + " ")])];
  })], 2)]), _c('div', {
    staticClass: "text-center mb-8"
  }, [_c('v-btn', {
    staticClass: "px-6 py-2 font-weight-bold rounded-pill",
    attrs: {
      "color": "primary",
      "elevation": 4
    },
    on: {
      "click": _vm.discoverOffers
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate('discoverOffers')) + " "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-arrow-forward")])], 1)], 1), _c('div', {
    staticClass: "contact-card-wrapper"
  }, [_c('div', {
    staticClass: "contact-card"
  }, [_c('div', {
    staticClass: "contact-label"
  }, [_vm._v(_vm._s(_vm.$translate('haveQuestion')))]), _c('div', {
    staticClass: "contact-divider"
  }), _c('div', {
    staticClass: "contact-links"
  }, [_c('a', {
    staticClass: "contact-link",
    attrs: {
      "href": "mailto:".concat(_vm.contactEmail)
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14"
    }
  }, [_vm._v("mdi-email-outline")]), _vm._v(" " + _vm._s(_vm.contactEmail) + " ")], 1), _vm.contactPhone ? _c('a', {
    staticClass: "contact-link",
    attrs: {
      "href": "tel:".concat(_vm.contactPhone)
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "14"
    }
  }, [_vm._v("mdi-phone-outline")]), _vm._v(" " + _vm._s(_vm.formattedPhone) + " ")], 1) : _vm._e()])])])])]), !_vm.inline ? _c('v-card-actions', {
    staticClass: "justify-end pa-4"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate('close')) + " ")])], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }